import request from '@/router/axios'
import env from '@/config/env'
import { pickBy } from 'lodash-es'
import qs from 'qs'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 查询供应商公司（供应商及其下属供应商）
 */
export const getAllLowMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchantPriceAdmin/getAllLowMerchant',
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 根据供应商获取车牌
 * @param spendingCompanyId
 */
export const getCar = (spendingCompanyId) => {
  return request({
    url: env.ferryUrl + `/settle-ticket-rule/car/${spendingCompanyId}`,
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取线路名称
 * @param id
 */
export const queryAllLowLine = (id) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/getLineByMerchantIds?merchantId=${id}`,
    method: 'GET',
    timeout: TIME
  })
}

/**
 * 获取结算单分页
 * @param statementsPageDto
 */
export const statementsPage = (statementsPageDto) => {
  return request({
    url: env.ferryUrl + '/statements/page',
    method: 'POST',
    timeout: TIME,
    data: statementsPageDto
  })
}

/**
 * 新增结算单
 * @param data
 */
export const saveStatementsCreate = (data) => {
  return request({
    url: env.ferryUrl + '/statements/create',
    method: 'POST',
    timeout: TIME,
    data: data
  })
}

/**
 * 获取结算单关联车和线路
 * @param data
 */
export const getCarLine = (data) => {
  return request({
    url: env.ferryUrl + '/statements/car-line',
    method: 'POST',
    timeout: TIME,
    data: data
  })
}

/**
 * 获取结算单详情详情
 * @param data
 */
export const statementsDetails = (statementId) => {
  return request({
    url: env.ferryUrl + `/statements/info/${statementId}`,
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 作废结算单
 * @param data
 */
export const invalidStatements = (statementId) => {
  return request({
    url: env.ferryUrl + `/statements/invalid-statements/${statementId}`,
    method: 'POST',
    timeout: TIME
  })
}

/**
 * 新增调账单
 * @param data
 */
export const createAdjustAccount = (data) => {
  return request({
    url: env.ferryUrl + '/statements/create/adjust-account',
    method: 'POST',
    timeout: TIME,
    data: data
  })
}
/**
 * 生成结算数据
 * @param data
 */
export const generateSettleData = (data) => {
  return request({
    url: env.ferryUrl + '/statements/generate/settle-data',
    method: 'POST',
    timeout: TIME,
    data: data
  })
}
/**
 * 导出结算明细
 * @param data
 */
// export const exportDetails = (data) => {
//   return request({
//     url: env.ferryUrl + '/settle/export/details',
//     method: 'GET',
//     data:data
//   })
// }

/**
 * 导出结算明细
 * @param data
 */
export const exportDetails = (queryParam) => {
  let url = env.importExcelUrl + env.ferryUrl + `/settle/export/details`
  let parma = pickBy({ ...queryParam })
  url = url + '?' + qs.stringify(parma)
  return (window.location.href = url)
}

/**
 * 删除调账单
 * @param id
 */
export const deleteAdjustAccount = (id) => {
  return request({
    url: env.ferryUrl + `/adjust-account/delete/${id}`,
    method: 'DELETE',
    timeout: TIME
  })
}
/**
 * 发送结算单
 * @param id
 */
export const sendSettleData = (params) => {
  return request({
    url: env.ferryUrl + `/statements/v2/send/settle-data`,
    method: 'POST',
    timeout: TIME,
    data: params
  })
}
/**
 * 新增打款记录
 * @param param
 */
export const transferRecord = (param) => {
  return request({
    url: env.ferryUrl + '/statements/transfer-record',
    method: 'POST',
    timeout: TIME,
    data: param
  })
}
/**
 * 确认记录上传附件
 * @param param
 */
export const confirmRecord = (param) => {
  return request({
    url: env.ferryUrl + '/statements/confirm-record',
    method: 'POST',
    timeout: TIME,
    data: param
  })
}
/**
 * 结算单明细生成
 * @param param
 */
export const createDetail = (param) => {
  return request({
    url: env.ferryUrl + '/statements-detail',
    method: 'POST',
    timeout: TIME,
    data: param
  })
}
/**
 * 结算单明细状态
 * @param id
 */
export const detailStatus = (statementId) => {
  return request({
    url: env.ferryUrl + `/statements-detail/${statementId}`,
    method: 'GET',
    timeout: TIME
  })
}
/**
 * 结算单明细状态
 * @param id
 */
export const statementsFile = (statementId) => {
  return request({
    url: env.ferryUrl + `/statements-file/list`,
    method: 'GET',
    timeout: TIME,
    params: statementId
  })
}
/**
 * 覆盖上传文件
 * @param id
 */
export const saveUploadAttachment = (param) => {
  return request({
    url: env.ferryUrl + `/statements-file/save`,
    method: 'POST',
    timeout: TIME,
    data: param
  })
}
/**
 * 根据供应商获取用户信息
 * @param id
 */
export const getByMerchantId = (params) => {
  return request({
    url: env.ferryUrl + `/user/getByMerchantId`,
    method: 'GET',
    timeout: TIME,
    params: params
  })
}
/**
 * 结算单同步数据
 * @param id
 */
export const statementsSync = (params) => {
  return request({
    url: env.ferryUrl + `/statements/sync`,
    method: 'POST',
    timeout: TIME,
    data: params
  })
}
/**
 * 删除已经上传保存的附件
 * @param id
 */
export const deleteStatementsFile = (id) => {
  return request({
    url: env.ferryUrl + `/statements-file/delete/${id}`,
    method: 'DELETE',
    timeout: TIME
  })
}
/**
 * 删除结算单
 * @param id
 */
export const deleteStatements = (id) => {
  return request({
    url: env.ferryUrl + `/statements/delete/${id}`,
    method: 'DELETE',
    timeout: TIME
  })
}
/**
 * 调账单批量保存
 * @param data
 */
export const batchSave = (data) => {
  return request({
    url: env.ferryUrl + `/adjust-account/batch-save`,
    method: 'POST',
    timeout: TIME,
    data: data
  })
}
/**
 * 批量上传车辆调账单模板下载
 * @param data
 */
export const downloadTemplate = (data) => {
  return request({
    url: env.ferryUrl + `/adjust-account/download-template`,
    method: 'GET',
    timeout: TIME
  })
}
/**
 * 获取审计日志信息
 * @param data
 */
export const getFinanceLog = (data) => {
  return request({
    url: env.ferryUrl + `/finance-log/list`,
    method: 'GET',
    timeout: TIME,
    params: data
  })
}
/**
 * 获取审计日志信息
 * @param data
 */
export const deleteBatchAdjust = (data) => {
  return request({
    url: env.ferryUrl + `/adjust-account/delete-batch`,
    method: 'POST',
    timeout: TIME,
    data: data
  })
}
// 校验结算单订单
export const checkOrder = (params) => {
  return request({
    url: env.ferryUrl + `/statements-check/check-order`,
    method: 'POST',
    params
  })
}
// 校验结算单订单
export const checkPage = (params) => {
  return request({
    url: env.ferryUrl + `/statements-check/check-page`,
    method: 'POST',
    data: params
  })
}
// 校验结算单订单
export const checkExport = (params) => {
  return request({
    url: env.ferryUrl + `/statements-check/check-export`,
    method: 'POST',
    params
  })
}
// 校验记录发送供应商
export const checkPush = (params) => {
  return request({
    url: env.ferryUrl + `/statements-check/check-push`,
    method: 'POST',
    data: params
  })
}
